import {
  CONFIRMED_CREATE_DISEASE_MEDICINE_MAPPING_ACTION,
  CONFIRMED_DELETE_DISEASE_MEDICINE_MAPPING_ACTION,
  CONFIRMED_EDIT_DISEASE_MEDICINE_MAPPING_ACTION,
  CONFIRMED_GET_DISEASE_MEDICINE_MAPPINGS,
} from "../actions/DiseaseMedicineMappingType";

import {
  createDiseaseMedicineMapping,
  formatDiseaseMedicineMappings,
  getDiseaseMedicineMappings,
  deleteDiseaseMedicineMapping,
  updateDiseaseMedicineMapping,
} from "../../services/DiseaseMedicineMappingService";

import swal from "sweetalert";
import { handleError, handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService";

// Get token from Redux or fallback to localStorage
function getAuthToken(getState) {
  const stateToken = getState().auth?.authKey;
  if (stateToken) return stateToken;

  const storedUser = localStorage.getItem('userDetails');
  return storedUser ? JSON.parse(storedUser).token : null;
}

export function getDiseaseMedicineMappingsAction(pagination = true, pageid = 0,search_by = "", search_keyword = "",sort_by = "", sort_order = "") {
  return async (dispatch, getState) => {
    try {
      const token = getAuthToken(getState);
      //console.log(admin_id, pagination, pageid, token);
      const response = await getDiseaseMedicineMappings(pagination, pageid,search_by,search_keyword, sort_by, sort_order,token);

      if (response && response.status === 200 && response.data) {
        if (response.data.status === "success" && response.data.data) {
          const mappings = formatDiseaseMedicineMappings(response.data.data);
          dispatch({ type: CONFIRMED_GET_DISEASE_MEDICINE_MAPPINGS, payload: mappings });
        } else {
          handleError("Failed to get disease medicine mappings: Server error");
        }
      } else {
        handleError("Failed to get disease medicine mappings: Network error");
      }
    } catch (error) {
      console.error("API Error:", error.response || error);
      showErrorAlert("Failed to get disease medicine mappings");
    }
  };
}

export function deleteDiseaseMedicineMappingAction(mapping, history) {
  return async (dispatch) => {
    try {
      const response = await deleteDiseaseMedicineMapping(mapping);
      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_DELETE_DISEASE_MEDICINE_MAPPING_ACTION,
          payload: { disease_medicine_id: mapping.disease_medicine_id }
        });
        handleSuccess("Disease-Medicine Mapping deleted successfully!");
      } else {
        showErrorAlert(response?.data?.message || "Failed to delete mapping");
      }
    } catch (error) {
      console.error(error);
      showErrorAlert("Failed to delete disease-medicine mapping");
    }
  };
}

export function createDiseaseMedicineMappingAction(mappingData) {
  return async (dispatch, getState) => {
    try {
      const token = getAuthToken(getState);
      const currentAdmin = getState().auth?.admin;
      const admin_id = currentAdmin?.admin_id;

      const newMapping = {
        ...mappingData,
        admin_id: admin_id || mappingData.admin_id,
      };

      const response = await createDiseaseMedicineMapping(newMapping, token);

      if (response?.data?.status === "success") {
        dispatch(getDiseaseMedicineMappingsAction());
        handleSuccess("Mapping created successfully!");
      } else {
        showErrorAlert(response?.data?.message || "Failed to create mapping");
      }
    } catch (error) {
      console.error("API Error:", error);
      showErrorAlert(error.response?.data?.message || "Failed to create mapping");
    }
  };
}

export function updateDiseaseMedicineMappingAction(mappingData) {
  return async (dispatch, getState) => {
    try {
      const token = getAuthToken(getState);
      const currentAdmin = getState().auth?.admin;
      const admin_id = currentAdmin?.admin_id;

      const updatedMapping = {
        ...mappingData,
        admin_id: admin_id || mappingData.admin_id,
      };

      const response = await updateDiseaseMedicineMapping(mappingData, token);

      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_EDIT_DISEASE_MEDICINE_MAPPING_ACTION,
          payload: updatedMapping,
        });
        handleSuccess("Mapping updated successfully!");
      } else {
        showErrorAlert(response?.data?.message || "Failed to update mapping");
      }
    } catch (error) {
      console.error("API Error:", error);
      showErrorAlert(error.response?.data?.message || "Failed to update mapping");
    }
  };
}

